<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100">

      <!-- Cover Image -->
      <div class="col-lg-6 p-0 position-relative d-none d-lg-block">
        <div class="fm-cover-image">
          <img src="images/signin/fm-signin-bg.png" alt="Reset Password" class="img-fluid" />
        </div>
      </div>

      <!-- Card -->
      <div class="col-lg-6">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-sm-11">
            <div class="fm-auth-card">

              <!-- Logo -->
              <div class="fm-auth-chead">
                <div class="fm-logo">
                  <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
                </div>
              </div>

              <!-- ── VERIFYING ── -->
              @if (pageState() === 'verifying') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-verifying mb-3">
                    <div class="fm-inv-spinner"></div>
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Validating Link</h3>
                  <p class="mb-0">Please wait while we validate your reset link…</p>
                </div>
              }

              <!-- ── ERROR ── -->
              @if (pageState() === 'error') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-error mb-3">
                    <img src="images/icons/fm-logout.svg" class="fm-svg fm-inv-state-icon" alt="Error" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Oops!</h3>
                  <p class="fm-inv-error-msg mb-3">{{ errorMessage() }}</p>
                  <p class="text-muted small mb-0">Redirecting to login in 3 seconds…</p>
                  <a routerLink="/login" class="fm-common-btn mt-4 d-inline-flex">Go to Login</a>
                </div>
              }

              <!-- ── SUCCESS ── -->
              @if (pageState() === 'success') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-success mb-3">
                    <img src="images/icons/fm-check.svg" class="fm-svg fm-inv-state-icon" alt="Success" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Password Reset!</h3>
                  <p class="mb-3">Your password has been reset successfully.</p>
                  <p class="text-muted small mb-0">Redirecting to login in 3 seconds…</p>
                  <a routerLink="/login" class="fm-common-btn mt-4 d-inline-flex">Go to Login</a>
                </div>
              }

              <!-- ── READY: Reset Password Form ── -->
              @if (pageState() === 'ready') {
                <div class="fm-auth-chead mt-0 pt-0">
                  <div class="d-flex align-items-center gap-3 mb-2">
                    <div class="fm-fp-icon mb-0">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </div>
                    <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold mb-0">Reset Password</h3>
                  </div>
                  <p>Enter your new password below to regain access to your account.</p>
                </div>

                <div class="fm-signin-form">
                    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
                    <fieldset class="row g-3 g-sm-4">

                      <!-- New Password -->
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">New Password <span class="fm-required">*</span></label>
                          <div class="fm-input-group">
                            <input [type]="showPassword() ? 'text' : 'password'"
                                   class="form-control"
                                   [class.is-invalid]="f['newPassword'].invalid && f['newPassword'].touched"
                                   formControlName="newPassword"
                                   placeholder="Enter New Password"
                                   autocomplete="new-password" />
                            <button type="button" class="fm-password-eye" (click)="togglePassword()">
                              <i [class]="showPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                            </button>
                          </div>
                          @if (f['newPassword'].errors?.['required'] && f['newPassword'].touched) {
                            <div class="fm-error-msg">Password is required.</div>
                          }
                          <!-- Password strength hints -->
                          @if (f['newPassword'].dirty || f['newPassword'].touched) {
                            <div class="fm-pw-hints">
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.minLength">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                At least 8 characters
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.maxLength">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                Max 12 characters
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasUpper">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 uppercase letter
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasNumber">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 number
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasSpecial">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 special character (@$!%*?&amp;)
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      <!-- Confirm Password -->
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Confirm Password <span class="fm-required">*</span></label>
                          <div class="fm-input-group">
                            <input [type]="showConfirmPassword() ? 'text' : 'password'"
                                   class="form-control"
                                   [class.is-invalid]="(f['confirmPassword'].invalid && f['confirmPassword'].touched) || passwordMismatch"
                                   formControlName="confirmPassword"
                                   placeholder="Re-Enter Password"
                                   autocomplete="new-password" />
                            <button type="button" class="fm-password-eye" (click)="toggleConfirmPassword()">
                              <i [class]="showConfirmPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                            </button>
                          </div>
                          @if (passwordMismatch) {
                            <div class="fm-error-msg">Passwords do not match.</div>
                          }
                        </div>
                      </div>

                      <!-- API Error -->
                      @if (submitError()) {
                        <div class="col-12">
                          <div class="fm-error-msg d-flex align-items-center gap-2">
                            <i class="bi bi-exclamation-circle-fill"></i>
                            {{ submitError() }}
                          </div>
                        </div>
                      }

                      <!-- Submit -->
                      <div class="col-12">
                        <button class="fm-common-btn w-100 mt-2 mt-lg-3" type="submit" [disabled]="isSubmitting()">
                          @if (isSubmitting()) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Resetting…
                          } @else {
                            Reset Password
                          }
                        </button>
                      </div>

                      <div class="col-12 text-center">
                        <p class="text-muted small mb-0">
                          Remember your password?
                          <a routerLink="/login" class="fm-basic-link">Back to Sign In</a>
                        </p>
                      </div>

                    </fieldset>
                  </form>
                </div>
              }

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
